import { render, staticRenderFns } from "./sectionInformation.vue?vue&type=template&id=04a92bff&scoped=true"
import script from "./sectionInformation.vue?vue&type=script&lang=js"
export * from "./sectionInformation.vue?vue&type=script&lang=js"
import style0 from "./sectionInformation.vue?vue&type=style&index=0&id=04a92bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a92bff",
  null
  
)

export default component.exports